import createHistory from 'history/createBrowserHistory';
import WebFont from 'webfontloader';
import 'tether';
import landingPage from './pages/landingPage';
import summaryPage from './pages/summaryPage';
import detailsPage from './pages/detailsPage';
import surveyPage from './pages/surveyPage';
import bottomLinePage from "./pages/bottomLinePage";
import {$, jqDoc} from './util/jq';
import supportsHistory from './util/supportsHistory';
import changePage from './pageTransitions';
import updateProgress from './updateProgress';
import centralDelivery from './centralDelivery';
import './messages';
import "../scss/main.scss";
import 'unslider/src/js/unslider.js';
import 'unslider/src/scss/unslider.scss';

console.log('Landing JS loaded');

if (!window._babelPolyfill) {
  require("babel-polyfill");
}

let history = null;
if (supportsHistory) {
  history = createHistory();
  history.listen((location, action) => {
    const previous = $('.previousAsync');
    if (action === 'POP' && previous.length) {
      console.log('User clicked the back button.  Manually clicking back for the user.');
      if (previous.length) {
        previous[0].click();
      }
    }
  });
}

const guide = {
  landingPage,
  summaryPage,
  detailsPage,
  surveyPage,
  bottomLinePage,
  history
};

window.guide = guide;

const ignite = window.ignite;

const navButtons = ['.next', '.previous', '.nextAsync', '.previousAsync'];

$(() => {
  centralDelivery();
  jqDoc.on('changePage', changePage);
  jqDoc.on('updateProgress', updateProgress);

  navButtons.forEach(selector => {
    $(jqDoc).on('click', selector, () => {
      $(selector).prop('disabled', true);
    });
  });

  jqDoc.on('focus', 'input', () => {
    $(this).select();
  });

  jqDoc.on('invalid.page', (event, data) => {
    if (event.namespace === 'page') {
      navButtons.forEach(selector => {
        $(selector).prop('disabled', false);
      });
      ignite.invalid({
        key: data.key,
        errors: data.errors.answer,
        type: data.type
      });
    }
  });

  jqDoc.on('valid.page', (event, data) => {
    ignite.valid(data);
  });

  jqDoc.on('satisfied', (event, data) => {
    ignite.satisfied(data);
  });

  jqDoc.on('satisfiedAnswer', (event, data) => {
    ignite.satisfied(data);
  });

  jqDoc.on('unsatisfied', (event, data) => {
    ignite.unsatisfied(data);
  });

  jqDoc.on('unsatisfiedAnswer', (event, data) => {
    ignite.unsatisfiedAnswer(data);
  });

  jqDoc.on('calculationChanged', (event, data) => {
    ignite.calculationChanged(data);
  });

  jqDoc.tooltip({
    placement: 'bottom',
    selector: '.infoTip',
    trigger: 'click',
    html: true,
    constraints: [
      {
        to: 'scrollParent',
        attachment: 'together'
      },
      {
        to: 'window',
        attachment: 'together',
        pin: true
      }
    ]
  });

  jqDoc.on('click', '.infoTip', function (event) {
    event.preventDefault();
  });

});

$(function() {
  // Remove 'hidden' from <html> and 'd-none' from #contentWrapper
  document.documentElement.classList.remove('hidden');
  var contentWrapper = document.getElementById('contentWrapper');
  if (contentWrapper) {
    contentWrapper.classList.remove('d-none');
  }
});

ignite.satisfied = event => {
  let selector, delay = 500;
  if (event.type === 'answer') {
    selector = $('#' + event.key + 'Div .' + event.key + '\.' + event.answerKey);
    delay = 0;
  }
  else {
    selector = $('#' + event.key + 'Div');
  }
  const view = event.view;
  if (selector.hasClass('unsatisfied')) {
    selector.removeClass('unsatisfied');
    selector.show('blind', delay, () => {
      selector.removeClass('invisible').find('.answer.spinner').each(ignite.enableSpinner);
    });
    // selector.css('display', 'block');
    switch (view) {
      case 'dropDown':
        selector.find('select').trigger('change');
        break;
      case 'radio':
      case 'checkbox':
        selector.find('input:checked').trigger('change');
        break;
      default:
        selector.find('input[type=text]').trigger('keyup');
        break;
    }
  }
};

function getContainerSelector(type) {
  if (type === 'questionGroup') {
    return '.group-error-container';
  }
  return '.error-container';
}

ignite.invalid = data => {

  const id = `${data.key}Div`;
  const element = $(`#${id}`);
  let errors = "";

  const errorContainer = element.find(getContainerSelector(data.type));
  if (data.errors) {
    errors = "<div>" + data.errors.join("</div><div>") + "</div>";
  }

  igniteGa('send', 'event', 'error', "displayed", id);

  errorContainer.html(errors);
  errorContainer.show('blind');

};

ignite.valid = ({key, type}) => {
  $(`#${key}Div`).find(getContainerSelector(type)).hide('blind');
};

$("#notesButton").on('click', () => {
  window.ignite.showNotes();
});

jqDoc.on('click', '.printButton', () => {
  window.print();
});

export default guide;


// WEBPACK FOOTER //
// ./src/main/js/index.js